import(/* webpackMode: "eager", webpackExports: ["RegisterForm"] */ "/repo/apps/web/src/app/register/RegisterForm.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/repo/node_modules/.pnpm/next@15.5.19_@babel+core@7.29.0_@opentelemetry+api@1.9.1_@playwright+test@1.59.1_react-_04fb5c2d92b284ce39741787871db659/node_modules/next/dist/client/app-dir/link.js");
